var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 57.04 56.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-6 {\n        isolation: isolate;\n      }\n\n      .cls-7 {\n        fill: #a8aaad;\n        mix-blend-mode: multiply;\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 22.53,
    y1: 52.06,
    x2: 20.78,
    y2: 44.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 35.79,
    y1: 49.31,
    x2: 34.07,
    y2: 42.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 11.3,
    y1: 37.98,
    x2: 6.82,
    y2: 43.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 41.96,
    y1: 36.38,
    x2: 54.17,
    y2: 43.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 39.41,
    cy: -7.25,
    fx: 39.41,
    fy: -7.25,
    r: 141.9,
    gradientTransform: "translate(20.98 22.84) scale(.26 .23)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e66025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd1f26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 15.93,
    y1: 55.13,
    x2: 15.86,
    y2: 21.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#959494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#cfd0d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 28.69,
    y1: 55.27,
    x2: 28.62,
    y2: 20.11,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 41.18,
    y1: 55.08,
    x2: 41.11,
    y2: 21.39,
    xlinkHref: "#linear-gradient-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M20.47,51.54c2.18.83,3.73-1.01,4.15-2.28l-5.39-4.85c-.04.65-.09,1.47-.14,2.46-.16,2.83.23,3.9,1.41,4.7l-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.13,46.7c-.05-.98-.1-1.79-.14-2.44l-5.59,5.03c.34,1.28,1.67,3.11,4.48,1.99,1.05-.78,1.4-1.88,1.25-4.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M22.38,51.62c-.07-.02-.14-.04-.21-.07l.11.1s.07-.02.1-.03Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.4,43.29c.89.8,1.9,1.28,2.83.66.4-.27.58-.83.65-1.38v-2.99l-6.23-5.62v3.23c0,3.87.89,4.59,4.19,7.38l-1.43-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.16,39.59v2.99c.07.55.24,1.11.65,1.38.93.62,1.93.14,2.83-.66l-1.43,1.29s0,0,0,0c3.3-2.8,4.19-3.52,4.19-7.38v-3.23l-6.23,5.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.93,24.29c1.48,1.33,1.48,3.47,0,4.8l-24.75,21.3c-1.46,1.32-3.86,1.32-5.33,0L1.11,28.09c-1.48-1.33-1.48-3.47,0-4.8L25.86.99c1.46-1.32,3.86-1.32,5.33,0l24.75,23.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M10.4,43.29c.89.8,1.9,1.28,2.83.66.4-.27.58-.83.65-1.38v-20.68l7.47-6.73v32.49c0,1.87-2.56,3.04-4.68,1.29l-2.79-2.51h0s-3.47-3.14-3.47-3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M15.59,20.33v.02l5.75-5.19v32.49c0,1.72-2.17,2.85-4.17,1.65h0c2.84,2.06,5.89.22,5.89-1.65V13.6l-7.47,6.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M44.82,41.94v-20.5l-9.13-8.21v1.94l7.47,6.73v20.68c.06.47.2.94.48,1.24,0,0,0,0,0,.01.05.05.1.09.15.13.07.04.13.08.2.11.02.01.04.02.06.03.05.02.09.04.14.06.02,0,.05.01.07.02.05.01.1.02.14.03.02,0,.04,0,.06.01.07,0,.13.02.2.02,0,0,0,0,0,0,.07,0,.14,0,.21-.01.02,0,.03,0,.05,0,.05,0,.11-.02.16-.03.02,0,.04,0,.06-.01.05-.01.11-.03.16-.05.02,0,.03-.01.05-.02.07-.03.14-.05.2-.08h0c.36-.17.71-.43,1.05-.73l-1.43,1.29s0,0,0,0c.96-.81,1.71-1.45,2.3-2.04-1.76,1.65-2.67.21-2.69-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M24.54,55.24c2.17,1.97,5.76,1.94,7.93-.03,1.75-1.59,3.59-3.25,4.43-3.94-3.35,1.35-4.6-1.48-4.6-2.61.01-5.57,0-27.15,0-36.57l-3.78-3.41-3.79,3.43c0,9.43-.01,30.98,0,36.55,0,1.13-1.7,3.86-4.26,2.88l4.07,3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M34.01,48.66c0-5.57,0-27.61,0-37.03l-4.35-3.86-1.13.91,3.78,3.41c0,9.42.01,31,0,36.57,0,.04,0,.08,0,.12.08,1.18,1.34,3.77,4.53,2.52.24-.2.49-.44.73-.74-1.65,1.22-3.57-.34-3.57-1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M46.64,43.29c-.89.8-1.9,1.28-2.83.66-.4-.27-.58-.83-.65-1.38v-20.68l-7.47-6.73v32.49c0,1.87,2.56,3.04,4.68,1.29l2.79-2.51h0s3.47-3.14,3.47-3.14Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/Finance.c5bf986a45c1a05483657d837f674438.svg";
export { ForwardRef as ReactComponent };